import { Empty, Segmented } from "antd";
import { GeneralTab } from "./GeneralTab";
import { useState } from "react";
import PoiTab from "./PoiTab";
import { LinkedForms } from "./FormsTab";
import { TaskHistory } from "./HistoryTab";
import trans from "../../../../utils";
import FormsPopup from "../../../Workforce/Forms/FormsPopup/FormsPopup";
import FormSubmissionPopup from "./FormSubmissionPopup";

const ViewTask = ({ data }) => {
  const [selected, setSelected] = useState("General");
  const [formPopup, setFormPopup] = useState("");
  const [formSubmissionPopup, setFormSubmissionPopup] = useState("");
  const renderContent = () => {
    switch (selected) {
      case "General":
        return <GeneralTab data={data} />;
      case "Location & POI":
        return data?.poiId ? <PoiTab data={data} /> : <Empty />;
      case "Linked Forms":
        return data?.forms.length > 0 ? (
          <LinkedForms
            data={data}
            setFormPopup={setFormPopup}
            setFormSubmissionPopup={setFormSubmissionPopup}
            formPopup={formPopup}
          />
        ) : (
          <Empty />
        );
      case "History":
        console.log("data:", data);
        return data?.statusHistory.length > 0 ? (
          <TaskHistory data={data} />
        ) : (
          <Empty />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Segmented
          options={[
            { label: trans("General"), value: "General" },
            { label: trans("Location & POI"), value: "Location & POI" },
            { label: trans("Linked Forms"), value: "Linked Forms" },
            { label: trans("History"), value: "History" },
          ]}
          block
          value={selected}
          onChange={setSelected}
        />

        <div style={{ marginTop: 16, flex: 1, overflowY: "auto" }}>
          {renderContent()}
        </div>
      </div>
      <FormsPopup
        formId={formPopup}
        type={"task"}
        onClose={() => setFormPopup("")}
      />
      <FormSubmissionPopup
        formId={formSubmissionPopup}
        onClose={() => setFormSubmissionPopup("")}
      />
    </>
  );
};

export default ViewTask;
